<ng-container *ngIf="time$ | async as time">
  <div class="time">
    <span class="time">{{ time | dateTimeFormat:'h:mm' }}</span>
    <span class="meridiem tk-proxima-nova-condensed">{{ time | dateTimeFormat:'A' }}</span>
  </div>

  <div class="date tk-proxima-nova-extra-condensed">{{ time | dateTimeFormat:'dddd, MMMM D' }}</div>
</ng-container>
